import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const associations: ThemeUICSSObject = {
  border: 'none',
  display: 'flex',
  gap: spacing(4),
  flexDirection: 'column',
  table: { width: '100%' },

  '.responsiveTable__wrapper': {
    height: '50vh',
    maxHeight: '50vh',
    overflow: 'auto',
  },

  '& > h2': {
    m: spacing(0),
  },

  '.associations__nodata': {
    p: spacing(7),
  },

  '.associations__buttons': {
    display: 'flex',
    justifyContent: 'end',
    gap: spacing(3),
    p: '3px',
  },

  '.contentExplorer > div': {
    overflowY: 'auto',
    overflowX: 'hidden',

    '.accordionElement': {
      '.content > div': {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(4),
        p: spacing(4),
      },
    },
  },

  '.responsiveTable__table': {
    width: '100%',
    variant: 'layout.common.tables.secondary',
  },

  '.association__entity[readonly]': {
    background: 'palette.background.paper',
  },
  /* PREPEND HERE */
};

export default associations;
